module.exports = __webpack_public_path__ + "img/p-13.e1d1a4d1.webp";